import React, {type JSX} from 'react';
import {Grow, ThemeProvider} from '@mui/material';
import {styled} from '@mui/material/styles';
import {SnackbarProvider} from 'notistack';
import {PageWrapper} from './components/shared';
import {theme} from './constants/theme';
import PageSwitcher from './components/pageSwitcher';
import NotificationAlert from './components/shared/notificationAlert';

const StyledSnackbarProvider = styled(SnackbarProvider)({
  '& .SnackbarProvider-containerRoot': {
    paddingTop: '144px',
  },
});

function HealthConnectModule(): JSX.Element {
  return (
    <ThemeProvider theme={theme}>
      <StyledSnackbarProvider
        TransitionComponent={Grow}
        Components={{
          success: NotificationAlert,
          error: NotificationAlert,
          warning: NotificationAlert,
          info: NotificationAlert,
          default: NotificationAlert,
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <PageWrapper>
          <PageSwitcher />
        </PageWrapper>
      </StyledSnackbarProvider>
    </ThemeProvider>
  );
}

export default HealthConnectModule;
